import React, { useEffect, useState, useRef } from "react";
import LayoutHOC from "../LayoutHOC";
import { useSidebar } from "../SidebarContext";
import { ReactComponent as ProjectFunnelIcon } from "../../assets/images/projectFunnel.svg";
import { ReactComponent as RightArrow } from "../../assets/images/icons/RightIcon.svg";
import Button from "../UniversalComponents/DefaultButton";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import {
  useFetchFunnelTypeQuery,
  useFetchFunnelStagesQuery,
  useUpdateFunnelStateMutation,
} from "../../utils/customer/funnelSlice";
import FunnelDashBoardCore from "./DashBoardFunnelComponents/FunnelDashBoardCore";
import { ReactComponent as NoFunnelIcon } from "../../assets/images/icons/NoFunnelIcon.svg";
import HighlightedParagraph from "../UniversalComponents/HighlightedParagraph";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import moment from "moment";
import AvatarName from "../UniversalComponents/AvatarName";
import ConfirmationDialog from "../UniversalComponents/ConfirmationDialogMulti";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { ReactComponent as CircleIcon } from "../../assets/images/icons/CircleIcon.svg";
import { getTitleCase } from "../../utils/utilityFunctions/stringUtility";
import { ReactComponent as AddField } from "../../assets/images/icons/LightblueIcon.svg";

const DashBoardFunnel = () => {
  const { data: funnelType, refetch: refetchFunnelTypes } = useFetchFunnelTypeQuery({});

  console.log(funnelType, "dddd");

  const [isNewFunnelBeingCreated, setNewFunnelBeingCreated] = useState(false); //to check if a new funnel is being created
  const [activeFunnel, setActiveFunnel] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [newFunnelName, setNewFunnelName] = useState("");
  const [newFunnelColor, setNewFunnelColor] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isExpanded, setIsExpanded] = useState(true);
  const [draftFunnelIds, setDraftFunnelIds] = useState(new Set());
  const [showDeployConfirmation, setShowDeployConfirmation] = useState(false);
  const [deployPayload, setDeployPayload] = useState(false);
  const [isColorFunnelPaletteOpen, setIsFunnelColorPaletteOpen] = useState(false);
  const editableRef = useRef(null);
  const dispatch = useDispatch();
  const activeFunnelRef = useRef(null);
  const copyButtonRef = useRef(null);

  useEffect(() => {
    if (isEditable && editableRef.current) {
      editableRef.current.focus();
      // cursor to end after focus
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(editableRef.current);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, [isEditable]);

  const { data: FunnelStages, refetch: RefetchStage } = useFetchFunnelStagesQuery({
    funnel_id: activeFunnel?.id,
  });

  console.log("FunnelStages:sa", FunnelStages);

  const [funnelStagesData, setFunnelStagesData] = useState([]);

  useEffect(() => {
    if (FunnelStages?.length > 0) setFunnelStagesData(FunnelStages);
  }, [FunnelStages]);

  //draft
  const [updateFunnelState] = useUpdateFunnelStateMutation();

  const handleFunnelClick = (item) => {
    setActiveFunnel(item);
    // RefetchStage();
    setNewFunnelBeingCreated(false);
  };

  useEffect(() => {
    if (activeFunnel?.id) RefetchStage();
  }, [activeFunnel?.id]);

  const handleAddNewClick = () => {
    // setActiveFunnel(null);
    // setFunnelStagesData([]);
    setNewFunnelName("");
    setNewFunnelColor("");
    setNewFunnelBeingCreated(true);
    setIsFunnelColorPaletteOpen(false);
  };

  const handleCopyFunnelSave = () => {
    setIsEditable(true);
    setNewFunnelName(`Copy - ${getTitleCase(activeFunnel?.funnel_name) || ""}`);
  };

  const handleDeployConfirmation = (newState) => {
    setDeployPayload(newState);
    setShowDeployConfirmation(newState);
  };

  const handleFunnelStateChange = async (newState) => {
    setShowDeployConfirmation(false);
    if (!activeFunnel?.id) return;

    if (!FunnelStages?.data || FunnelStages.data.length === 0) {
      dispatch(
        pushAlert({
          type: "danger",
          message: "Add at least one stage before completing the funnel deployment.",
          visible: true,
        })
      );
      return;
    }

    try {
      const response = await updateFunnelState({
        funnelId: activeFunnel.id,
        payload: { state: newState },
      }).unwrap();

      if (response.status) {
        dispatch(
          pushAlert({
            type: "success",
            message: response.message || "Funnel state updated.",
            visible: true,
          })
        );

        //  FIXED: update draft funnel IDs
        setDraftFunnelIds((prev) => {
          const updated = new Set(prev);
          if (newState === "draft") {
            updated.add(activeFunnel.id);
          } else {
            updated.delete(activeFunnel.id);
          }
          return updated;
        });

        setActiveFunnel((prev) => ({
          ...prev,
          state: newState,
        }));

        refetchFunnelTypes();
      } else {
        dispatch(
          pushAlert({
            type: "danger",
            message: response.message || "Failed to update funnel state.",
            visible: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          type: "danger",
          message: error?.data?.message || "Something went wrong.",
          visible: true,
        })
      );
    }
  };

  const getInitials = (name) => {
    return name
      ? name
          .split(" ")
          .filter((word) => word.length > 0)
          .slice(0, 2)
          .map((word) => word.charAt(0).toUpperCase())
          .join("")
      : "";
  };

  const createdInitials = getInitials(activeFunnel?.created_by);
  const updatedInitials = getInitials(activeFunnel?.updated_by);

  useEffect(() => {
    if (funnelType?.data?.length > 0) {
      const draftIds = new Set(funnelType.data.filter((funnel) => funnel.state === "draft").map((funnel) => funnel.id));
      setDraftFunnelIds(draftIds);
    }
  }, [funnelType]);

  console.log(FunnelStages);

  useEffect(() => {
    console.log(activeFunnel, funnelType, isNewFunnelBeingCreated, "funnelType?.data");
    // If there are funnels available and no active funnel is set, set the first funnel as
    if (funnelType?.data?.length > 0 && !activeFunnel?.funnel_name && !isNewFunnelBeingCreated) {
      const firstFunnel = funnelType.data[0];
      setActiveFunnel(firstFunnel);
    }
  }, [funnelType?.data]);

  useEffect(() => {
    if (activeFunnelRef.current && activeFunnelRef.current.scrollIntoView) {
      activeFunnelRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [activeFunnelRef.current]);

  console.log(activeFunnel?.funnel_name, "activeFunnel");
  return (
    <>
      <div className="w-full h-full flex flex-col">
        {/* header of the dashboard funnel */}
        <div className="flex justify-between items-center px-5 py-4 border-t  border-black/10  bg-white">
          <div className="flex gap-3 items-center ">
            {/* <ProjectFunnelIcon /> */}
            <div className="text-[#383838] font-poppins text-xl font-semibold">Project Funnel</div>
          </div>
          <div className="flex gap-2">
            {activeFunnel?.funnel_name && (
              <div ref={copyButtonRef}>
                <Button className="whitespace-nowrap w-full px-4 " variant="secondary" onClick={handleCopyFunnelSave}>
                  Copy & New
                </Button>
              </div>
            )}
            {funnelType?.data?.length > 0 && (
              <button
                className="group cursor-pointer border border-[#5489FF] text-[#5489FF] hover:border-[#004EFF] hover:text-[#004EFF] rounded-md flex items-center gap-2 px-3 h-[30px]"
                onClick={handleAddNewClick}
              >
                <AddField className="w-4 h-4 fill-[#5489FF] group-hover:fill-[#004EFF]" />
                Add New
              </button>
            )}
          </div>
        </div>
        {/* main body divided into three parts l1, l2 and l3 */}
        <div className="px-[21px] pb-[15px] flex gap-5 w-full min-h-0 grow">
          <div className="w-full flex gap-4">
            <div className="w-[22%] h-full flex flex-col rounded-[5px] bg-white shadow-[0_0_4px_0_rgba(0,0,0,0.25)] overflow-y-hidden">
              {funnelType?.data?.length > 0 && (
                <div className="flex flex-col pt-3 pb-2 pr-4 pl-4">
                  <MotionSearchBox
                    isSearchActive={isExpanded}
                    setIsSearchActive={setIsExpanded}
                    expanded={true}
                    searchText={searchTerm}
                    setSearchText={setSearchTerm}
                    ClassName="text-sm border-transparent"
                  />
                  <div className="h-[0.5px] bg-[#D2DAE1] mt-1"></div>
                </div>
              )}

              <div className="flex flex-col pr-1 pl-4 overflow-auto min-h-0 grow thinscrollbar gap-y-3 mb-1.5">
                <style>
                  {`
                  .thinscrollbar::-webkit-scrollbar {
                    width: 6px;
                    background-color: transparent;
                  }

                  .thinscrollbar::-webkit-scrollbar-thumb {
                    border-radius: 4px;
                    background-color: transparent;
                  }

                  .thinscrollbar:hover::-webkit-scrollbar-thumb {
                    background-color: grey;
                  }

                  .thinscrollbar {
                    scrollbar-width: thin;
                    scrollbar-color: transparent transparent;
                  }

                  .thinscrollbar:hover {
                    scrollbar-color: grey transparent;
                  }
                `}
                </style>
                {funnelType?.data?.length > 0 ? (
                  funnelType.data
                    .filter((item) => item.funnel_name.toLowerCase().includes(searchTerm.toLowerCase()))
                    .map((item) => (
                      <div
                        key={item.id}
                        className={`flex justify-between items-center rounded-[5px] cursor-pointer px-[15px] py-2  
                            ${
                              activeFunnel?.id === item?.id
                                ? "text-[#131313cc] border font-semibold "
                                : "text-[#13131399] font-medium hover:bg-[#F8FAFF]"
                            }
                            font-[Poppins] text-base not-italic leading-[18px] 
                            ${item.funnel_color && item.funnel_color !== "#FFFFFF" ? "" : ""}
                          `}
                        style={{
                          border:
                            activeFunnel?.id === item?.id
                              ? item.funnel_color && item.funnel_color !== "#FFFFFF"
                                ? `1.6px solid ${hexToRgba(item.funnel_color, 0.32)}`
                                : "1.6px solid #D2DAE1"
                              : "1.6px solid transparent",
                          backgroundColor:
                            activeFunnel?.id === item?.id
                              ? item.funnel_color && item.funnel_color !== "#FFFFFF"
                                ? hexToRgba(item.funnel_color, 0.08)
                                : hexToRgba("#D2DAE1", 0.08)
                              : undefined,

                          // borderLeftColor:
                          //   item.funnel_color && item.funnel_color !== "#FFFFFF"
                          //     ? hexToRgba(item.funnel_color, 0.4)
                          //     : "#D2DAE1",
                        }}
                        onClick={() => handleFunnelClick(item)}
                        ref={activeFunnel?.id === item?.id ? activeFunnelRef : null}
                      >
                        <div className={`flex items-center justify-between w-full`}>
                          <div className="flex items-center gap-4">
                            {/* <HighlightedParagraph paragraph={item?.funnel_name} searchTerm={searchTerm} /> */}

                            <div>
                              <div className="whitespace-pre-wrap flex items-center gap-4">
                                {/* <CircleIcon
                                  fill={
                                    item.funnel_color && item.funnel_color !== "#FFFFFF"
                                      ? item.funnel_color || "#13131324"
                                      : "#13131324"
                                  }
                                /> */}
                                <CircleIcon
                                  fill={
                                    activeFunnel?.id === item?.id
                                      ? item.funnel_color && item.funnel_color !== "#FFFFFF"
                                        ? item.funnel_color
                                        : "#13131324"
                                      : "#13131324"
                                  }
                                />

                                <HighlightedParagraph
                                  paragraph={
                                    getTitleCase(item?.funnel_name)?.slice(0, 18) +
                                    (item?.funnel_name?.length > 18 ? "..." : "")
                                  }
                                  searchTerm={searchTerm}
                                />
                              </div>
                            </div>

                            {/* Show funnel state based on actual item.state */}
                            {item.state === "draft" && (
                              <span
                                className={`text-10 font-normal rounded-[5px] px-2 py-[1px] border-[#D2DAE1] border ${
                                  activeFunnel?.id === item?.id ? "text-[#13131399]" : "text-[#13131399]"
                                }`}
                              >
                                (Draft)
                              </span>
                            )}

                            {/* {item.state === "active" && (
                                <span
                                  className={`text-xs font-normal rounded px-2 bg-[#d1fae5] py-[2px] ${
                                    activeFunnel?.funnel_name === item?.funnel_name
                                      ? "text-white"
                                      : "text-[#065f46]"
                                  }`}
                                >s
                                  Deployed
                                </span>
                              )} */}
                          </div>

                          {/* {activeFunnel?.id === item?.id && <RightArrow />} */}
                        </div>
                      </div>
                    ))
                ) : (
                  <div className="flex flex-col items-center justify-center h-full text-[#131313cc] font-Inter text-base font-semibold gap-2 text-center">
                    {/* <NoFunnelIcon /> */}
                    <span>
                      Section created by you will <br /> be displayed here.
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* center part where funnel and its corresponding stages are being displayed, both in read mode and edit mode */}
            <div className="w-[45%] h-full">
              <FunnelDashBoardCore
                activeFunnel={activeFunnel}
                isNewFunnelBeingCreated={isNewFunnelBeingCreated}
                setNewFunnelBeingCreated={setNewFunnelBeingCreated}
                setActiveFunnel={setActiveFunnel}
                FunnelStages={FunnelStages}
                RefetchStage={RefetchStage}
                funnelType={funnelType}
                refetchFunnelTypes={refetchFunnelTypes}
                isEditable={isEditable}
                editableRef={editableRef}
                setNewFunnelName={setNewFunnelName}
                newFunnelName={newFunnelName}
                setIsEditable={setIsEditable}
                funnelStagesData={funnelStagesData}
                setFunnelStagesData={setFunnelStagesData}
                newFunnelColor={newFunnelColor}
                setNewFunnelColor={setNewFunnelColor}
                copyButtonRef={copyButtonRef}
                handleAddNewClick={handleAddNewClick}
                isColorFunnelPaletteOpen={isColorFunnelPaletteOpen}
                setIsFunnelColorPaletteOpen={setIsFunnelColorPaletteOpen}
              />
            </div>
          </div>

          <div className=" relative">
            {activeFunnel?.funnel_name && (
              <>
                {/* <div className="border border-[#D2DAE1] rounded  bg-[#F8FAFF]">
                   <div className="p-3 px-4 flex gap-3">
                            <span className="text-[#1D4469] text-lg font-semibold capitalize">{activeFunnel?.funnel_name}</span>
                          </div>
                          <div className="h-[0.5px]  bg-[#D2DAE1]" /> 

                   <div className="flex gap-2 px-4 py-3">
                    <div className="relative flex flex-col items-center py-2.5">
                      <AvatarName
                        name={createdInitials}
                        size="medium"
                        bgColor="#e8ecf299"
                        textColor="#7C7C83"
                        borderColor="#ABABAC"
                      />

                      <div className="w-[1px] bg-[#DFE2E5] flex-1" />

                      <AvatarName
                        name={updatedInitials}
                        size="medium"
                        bgColor="#e8ecf299"
                        textColor="#7C7C83"
                        borderColor="#ABABAC"
                      />
                    </div>

                    <div className="flex flex-col justify-between  pl-2 py-1 gap-5">
                      <div>
                        <span className="text-[#13131399] font-normal text-sm">
                          Created by{" "}
                          <span className="text-[#131313cc] font-medium text-sm">{activeFunnel?.created_by}</span>
                        </span>
                        <div className="text-[#767676] font-normal text-[11px]">
                          {moment(activeFunnel?.created_at).format("DD MMM YYYY, hh:mm A")}
                        </div>
                      </div>

                      <div>
                        <span className="text-[#13131399] font-normal text-sm">
                          Updated by{" "}
                          <span className="text-[#131313cc] font-medium text-sm">{activeFunnel?.updated_by}</span>
                        </span>
                        <div className="text-[#767676] font-normal text-[11px]">
                          {moment(activeFunnel?.updated_at).format("DD MMM YYYY, hh:mm A")}
                        </div>
                      </div>
                    </div>
                  </div> 
                </div> */}

                {activeFunnel?.funnel_name && (
                  <span className="absolute bottom-0 right-0 flex gap-2">
                    {/* <Button
                className="whitespace-nowrap w-full px-2 py-2"
                variant="secondary"
                onClick={() => handleFunnelStateChange("draft")}
              >
                Save as Draft
              </Button> */}
                    <Button
                      className={`whitespace-nowrap w-full px-4 ${activeFunnel?.state === "active" ? "cursor-not-allowed opacity-20" : ""}`}
                      variant="primary"
                      onClick={() => handleDeployConfirmation("active")}
                      isDisabled={activeFunnel?.state === "active"}
                    >
                      Save & Deploy
                    </Button>
                  </span>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {showDeployConfirmation && (
        <ConfirmationDialog
          open={showDeployConfirmation}
          onConfirm={() => handleFunnelStateChange(deployPayload)}
          onClose={() => setShowDeployConfirmation(false)}
          title="Confirm Funnel Deployment?"
          message={
            <>
              You are about to deploy this funnel. Once deployed, it cannot be edited or changed.
              <br />
              Are you sure you want to proceed?
            </>
          }
          confirmVariant="primary"
          iconVariant="primary"
          confirmText="Yes"
          cancelText="No"
        />
      )}
    </>
  );
};

export default DashBoardFunnel;
